import AOS from 'aos';
import 'aos/dist/aos.css';

/**
 * Initializes AOS (scroll animations) site-wide and exposes it on `window`
 * so flip-blocks view.js files (a separate JS bundle) can call
 * `window.AOS.refreshHard()` after injecting new `data-aos` elements
 * (e.g. AJAX "Load more") without bundling their own copy of the library.
 */
export function initAOS() {
  window.AOS = AOS;

  AOS.init({
    once: true,
    duration: 600,
    offset: 80,
    disable: 'mobile',
  });

  // Trigger positions are calculated at DOMContentLoaded, before web fonts and
  // images finish loading — their late layout shifts leave AOS with stale
  // (usually much-too-large) offsets, so elements don't animate in until the
  // page is scrolled almost all the way to them. Recalculate once everything
  // has actually finished loading.
  window.addEventListener('load', () => AOS.refresh());
}
